module.exports = __webpack_public_path__ + "static/media/cloud.4a69f7c9.svg";